import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import Box from '../Box';

var TableContainer = function TableContainer(props) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    role: "table",
    shrink: 1,
    grow: 1,
    backgroundColor: "white",
    position: "relative"
  }, props));
};

export default TableContainer;